<app-page-breadcrumb pageTitle="Tickets — Kanban"></app-page-breadcrumb>

<!-- Main Container -->
<div class="w-full max-w-full">

  <!-- Compact Controls Section -->
  <div class="mb-3 w-full">
    <div class="flex items-center justify-between gap-2 flex-wrap">

      <!-- Filtro responsable + selector pipeline -->
      <div class="flex items-center gap-2 flex-wrap">
        <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
          <button
            type="button"
            (click)="setOwnerFilter('all')"
            class="px-3 py-1.5 text-sm font-medium transition-colors"
            [ngClass]="filtroOwner === 'all'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
            Todos
          </button>
          <button
            type="button"
            (click)="setOwnerFilter('mine')"
            class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
            [ngClass]="filtroOwner === 'mine'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
            Mis tickets
          </button>
        </div>

        @if (pipelines.length > 0) {
          <select
            [ngModel]="selectedPipelineId"
            (ngModelChange)="onChangePipeline($event)"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            @for (pipeline of pipelines; track pipeline.id) {
              <option [ngValue]="pipeline.id">
                {{ pipeline.name }}{{ pipeline.isDefault ? ' (default)' : '' }}
              </option>
            }
          </select>
        }
      </div>

      <!-- Action buttons -->
      <div class="flex items-center gap-1.5">
        <button
          type="button"
          (click)="toggleFilters()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
          </svg>
          {{ showFilters ? 'Ocultar' : 'Filtros' }}
        </button>
        <button
          type="button"
          (click)="vistaLista()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
          Lista
        </button>
        <button
          type="button"
          (click)="nuevoTicket()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          Nuevo
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Panel -->
  @if (showFilters) {
  <div class="mb-3 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 w-full">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">

      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Buscar</label>
        <input
          type="text"
          [(ngModel)]="filtroTexto"
          (ngModelChange)="buscar()"
          placeholder="#ticket, asunto, contacto o empresa…"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Prioridad</label>
        <select
          [(ngModel)]="filtroIdPriority"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todas</option>
          @for (priority of priorities; track priority.id) {
            <option [ngValue]="priority.id">{{ priority.label }}</option>
          }
        </select>
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Categoría</label>
        <select
          [(ngModel)]="filtroIdCategory"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todas</option>
          @for (category of categories; track category.id) {
            <option [ngValue]="category.id">{{ category.name }}</option>
          }
        </select>
      </div>

      <div class="flex items-end">
        <button
          type="button"
          (click)="limpiarFiltro()"
          class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
          Limpiar Filtros
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Loading State -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
  </div>
  }

  <!-- Error State -->
  @if (error) {
  <div class="bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800 text-error-700 dark:text-error-400 px-4 py-3 rounded mb-6">
    {{ error }}
  </div>
  }

  <!-- Kanban Board -->
  @if (!loading && !error && columns.length > 0) {
  <div class="kanban-container overflow-x-auto w-full">
    <div class="flex gap-4 pb-4" style="min-width: fit-content;">

      @for (column of columns; track column.stageId) {
      <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 min-w-72 w-72 flex-shrink-0">

        <!-- Header de la columna -->
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            @if (column.stageColor) {
              <div class="w-3 h-3 rounded-full" [style.background-color]="column.stageColor"></div>
            } @else {
              <div class="w-3 h-3 rounded-full {{ getStageDotColor(column) }}"></div>
            }
            <h3 class="font-semibold text-gray-900 dark:text-white">{{ column.stageName }}</h3>
          </div>
          <span class="text-xs font-medium text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-700 px-2 py-1 rounded">
            {{ column.cards.length }}@if (column.totalCount > column.cards.length) { / {{ column.totalCount }} }
          </span>
        </div>

        <!-- Lista de cards con drag & drop -->
        <div
          cdkDropList
          [id]="'col-' + column.stageId"
          [cdkDropListData]="column.cards"
          [cdkDropListConnectedTo]="getColumnIds()"
          (cdkDropListDropped)="drop($event)"
          class="min-h-125 max-h-175 overflow-y-auto space-y-3">

          @for (card of column.cards; track card.id) {
          <div cdkDrag
            (click)="verDetalle(card)"
            class="bg-white dark:bg-gray-900 rounded-lg p-4 shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-shadow relative group cursor-pointer">

            <!-- Botones de acción -->
            <div class="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
              <button type="button"
                (click)="verDetalleModal(card); $event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                class="p-1.5 bg-brand-500 hover:bg-brand-600 text-white rounded transition-colors cursor-pointer"
                title="Ver detalle">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                </svg>
              </button>
              <button type="button"
                (click)="editarTicket(card, $event); $event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                class="p-1.5 bg-brand-500 hover:bg-brand-600 text-white rounded transition-colors cursor-pointer"
                title="Editar">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                </svg>
              </button>
              <!-- Inc 8: Archivar (icono de caja) y Eliminar (papelera) homologados con la vista Lista -->
              <button type="button"
                *appHasPermission="'tickets:edit'"
                (click)="archivarTicket(card, $event); $event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                class="p-1.5 bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors cursor-pointer"
                title="Archivar">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4h16v4H4V4zm1 4h14v11a1 1 0 01-1 1H6a1 1 0 01-1-1V8zm4.5 4h5"></path>
                </svg>
              </button>
              <button type="button"
                *appHasPermission="'tickets:delete'"
                (click)="eliminarTicket(card, $event); $event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                class="p-1.5 bg-error-500 hover:bg-error-600 text-white rounded transition-colors cursor-pointer"
                title="Eliminar">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>
              </button>
            </div>

            <!-- Número del ticket -->
            <p class="text-xs text-gray-400 mb-1 font-mono">{{ card.ticketNumber }}</p>

            <!-- Asunto -->
            <h4 class="font-medium text-gray-900 dark:text-white mb-2 pr-20">
              {{ card.subject }}
            </h4>

            <!-- Owner -->
            @if (card.intIdUserOwner != null) {
            <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
              <span class="truncate" [title]="'Identificador interno: ' + card.intIdUserOwner">{{ card.ownerUserName || 'Responsable sin nombre disponible' }}</span>
            </div>
            }

            <!-- Contacto -->
            @if (card.idContact != null) {
            <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
              <span class="truncate" [title]="'Identificador interno: ' + card.idContact">{{ card.contactName || 'Contacto sin nombre disponible' }}</span>
            </div>
            }

            <!-- Empresa -->
            @if (card.idCompany != null) {
            <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0H5m14 0h2M5 21H3m4-14h.01M11 7h.01M15 7h.01M7 11h.01M11 11h.01M15 11h.01M7 15h.01M11 15h.01M15 15h.01"></path>
              </svg>
              <span class="truncate" [title]="'Identificador interno: ' + card.idCompany">{{ card.companyName || 'Empresa sin nombre disponible' }}</span>
            </div>
            }

            <!-- Badges -->
            <div class="flex flex-wrap gap-2 mt-3">
              @if (card.idTicketPriority != null) {
                <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium {{ getPriorityColor(card.idTicketPriority) }}">
                  {{ getPriorityLabel(card.idTicketPriority) }}
                </span>
              }
            </div>

            <!-- Indicador de arrastre -->
            <div class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800 flex justify-center">
              <div class="w-8 h-1 bg-gray-300 dark:bg-gray-600 rounded"></div>
            </div>
          </div>
          }

          <!-- Estado vacío -->
          @if (column.cards.length === 0 && !loading) {
          <div class="flex flex-col items-center justify-center py-12 text-gray-400 dark:text-gray-600">
            <svg class="w-12 h-12 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
            <p class="text-sm">No hay tickets</p>
          </div>
          }

        </div>
      </div>
      }

    </div>
  </div>
  }

  @if (!loading && !error && columns.length === 0) {
  <div class="flex flex-col items-center justify-center py-12 text-gray-400 dark:text-gray-600">
    <p class="text-sm">El pipeline seleccionado no tiene etapas configuradas.</p>
  </div>
  }

</div>

<app-tickets-detail-modal
  [isOpen]="showDetailModal"
  [ticket]="selectedTicket"
  [priorities]="priorities"
  [statuses]="statuses"
  [categories]="categories"
  [pipelines]="pipelines"
  [stages]="stages"
  (refetch)="cargarKanban()"
  (close)="cerrarModalDetalle()">
</app-tickets-detail-modal>
